import { NextSearchParams } from '@/types/general'

export const generateSearchParams = (searchParams: NextSearchParams) => {
    const flattedParams: string[] = []

    if (searchParams) {
        Object.keys(searchParams).forEach((key) => {
            const value = searchParams[key]
            if (Array.isArray(value)) {
                value.forEach((v) => flattedParams.push(`${encodeURIComponent(key)}=${encodeURIComponent(v)}`))
            } else if (value) {
                flattedParams.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
            }
        })
    }

    const finalSearchParams = new URLSearchParams(flattedParams.join('&'))

    return finalSearchParams
}
